module.exports = __webpack_public_path__ + "img/background050.7119f66c.jpg";